import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/manga';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
        <div className={`absolute inset-0 bg-gradient-to-b ${banner.color}`}></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background-50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/90 text-background-50 dark:text-foreground-950 rounded-full mb-4">
                热门推荐
              </span>
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3 leading-tight">
                {banner.title}
              </h1>
              <p className="text-base md:text-lg text-background-100/90 mb-6 max-w-lg">
                {banner.subtitle}
              </p>
              <div className="flex items-center gap-3">
                <Link
                  to={`/manga/${banner.mangaId}`}
                  className="px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  立即阅读
                </Link>
                <Link
                  to="/category/all"
                  className="px-6 py-3 text-sm font-medium bg-background-50/20 text-background-50 backdrop-blur-sm rounded-full hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer border border-background-50/30"
                >
                  浏览更多
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第${index + 1}个推荐`}
          />
        ))}
      </div>
    </section>
  );
}